import { render, staticRenderFns } from "./CenterCmp.vue?vue&type=template&id=73eb6a8c&"
import script from "./CenterCmp.vue?vue&type=script&lang=js&"
export * from "./CenterCmp.vue?vue&type=script&lang=js&"
import style0 from "./CenterCmp.vue?vue&type=style&index=0&id=73eb6a8c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports